(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Sticky mobile order CTA: stay hidden while a section that already has its
  // own CTA is in view — the hero (top) or the footer CTA band (bottom) — and
  // show it in between. Pages with neither keep the button visible.
  (function () {
    var cta = document.querySelector('.nutri-mobile-cta');
    if (!cta || !('IntersectionObserver' in window)) return;
    var hero = document.querySelector('.nutri-hero');
    var footerCta = document.querySelector('.nutri-cta__band');
    var footer = document.querySelector('.footer') || document.querySelector('footer');
    var watch = [hero, footerCta, footer].filter(Boolean);
    if (!watch.length) return;
    if (hero) cta.classList.add('nutri-mobile-cta--hidden'); // avoid a flash before the observer fires
    var seen = new Array(watch.length);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { seen[watch.indexOf(e.target)] = e.isIntersecting; });
      cta.classList.toggle('nutri-mobile-cta--hidden', seen.some(Boolean));
    }, { threshold: 0 });
    watch.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutri-builder"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initBuilder(root) {
    if (!root || root.dataset.inited) return;
    root.dataset.inited = '1';

    var data = {};
    try { data = JSON.parse(root.querySelector('[data-builder-data]').textContent); } catch (e) { return; }
    var boxes = (data.boxes || []).filter(function (b) { return b.available && b.punnets > 0; })
      .sort(function (a, b) { return a.punnets - b.punnets; });
    var sizes = boxes.map(function (b) { return b.punnets; });
    // Portion model, all grounded in grams per serving:
    var punnetGrams = parseFloat(data.weight) || 60;          // grams in one punnet (from e.g. "60g")
    var gramsPerServing = parseFloat(data.gramsPerServing) || 10;
    var daysPerWeek = parseInt(data.daysPerWeek, 10) || 7;
    var servings = Math.max(1, Math.round(punnetGrams / gramsPerServing)); // servings per punnet (60/10 = 6)
    var greensMin = Math.max(1, parseInt(root.dataset.greensMin, 10) || 1); // min favourites to continue

    var q = function (sel) { return root.querySelector(sel); };
    var qa = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    var state = { step: 0, people: null, greens: [], meals: [], plan: 'month', box: sizes[0] || 4, slots: {} };

    function fmtMoney(cents) {
      var amt = (cents / 100);
      var fmt = data.moneyFormat || '$\u007B\u007Bamount\u007D\u007D'; // "$" + Shopify money placeholder, brace-escaped for the Liquid-in-JS lint
      var withComma = amt.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return fmt
        .replace(/\{\{\s*amount\s*\}\}/g, amt.toFixed(2))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(amt).toString());
    }
    function boxFor(p) { for (var i = 0; i < boxes.length; i++) { if (boxes[i].punnets === p) return boxes[i]; } return null; }
    function oneTimeCents(b) { return b ? b.price : 0; }
    // Match a real selling plan on the variant by a keyword in its name (e.g. "month" / "week").
    function planFor(b, kw) {
      if (!b || !b.plans || !kw) return null;
      kw = kw.toLowerCase();
      for (var i = 0; i < b.plans.length; i++) {
        if (((b.plans[i].name || '').toLowerCase()).indexOf(kw) > -1) return b.plans[i];
      }
      return null;
    }
    function monthPlan(b) { return planFor(b, data.monthKw || 'month'); }
    function weekPlan(b) { return planFor(b, data.weekKw || 'week'); }
    function chosenPlan(b) { return state.plan === 'month' ? monthPlan(b) : (state.plan === 'week' ? weekPlan(b) : null); }
    // Price comes straight from the selling plan (Appstle handles the billing/delivery schedule).
    // The monthly plan's price already covers a whole month (several weekly boxes); monthWeeks
    // is how many — used ONLY for the strike-through "was" + per-serving maths, not the charge.
    var monthWeeks = Math.max(1, parseInt(data.monthWeeks, 10) || 1);
    function planCents(b) { var p = chosenPlan(b); return p ? p.price : oneTimeCents(b); }
    function pctOff(was, now) { return (was && now != null && now < was) ? Math.round((1 - now / was) * 100) : 0; }

    /* ---- people ---- */
    qa('[data-people] .tile').forEach(function (t) {
      t.addEventListener('click', function () {
        qa('[data-people] .tile').forEach(function (x) { x.classList.remove('sel'); });
        t.classList.add('sel'); state.people = parseInt(t.dataset.v, 10); validate();
      });
    });

    /* ---- greens ---- */
    qa('[data-varieties] .variety').forEach(function (b) {
      b.addEventListener('click', function () {
        var key = b.dataset.key, i = state.greens.indexOf(key);
        if (i > -1) state.greens.splice(i, 1); else state.greens.push(key);
        b.classList.toggle('sel'); updateVarCount(); validate();
      });
    });
    function updateVarCount() {
      var n = state.greens.length, el = q('[data-var-count]');
      var suffix = el.dataset.suffix || "selected – You can update your selection on your account page at any time";
      if (n === 0) {
        el.innerHTML = el.dataset.empty || ('Pick at least ' + greensMin + ' options to continue');
      } else if (n < greensMin) {
        el.innerHTML = '<b>' + n + '</b> selected — pick at least <b>' + greensMin + '</b> to continue';
      } else {
        el.innerHTML = '<b>' + n + '</b> ' + (n === 1 ? 'favourite' : 'favourites') + ' ' + suffix;
      }
    }
    q('[data-var-count]').dataset.empty = q('[data-var-count]').textContent;

    /* ---- meals ---- */
    qa('[data-meals] .meal').forEach(function (m) {
      m.addEventListener('click', function () {
        var v = m.dataset.v, i = state.meals.indexOf(v);
        if (i > -1) state.meals.splice(i, 1); else state.meals.push(v);
        m.classList.toggle('sel'); validate();
      });
    });

    /* ---- recommendation ---- */
    function recommendBox() {
      if (!sizes.length) return 4;
      // One serving (gramsPerServing) per person, per selected meal, per day, across the week.
      var servingsPerDay = Math.max(1, state.meals.length);
      var weeklyGrams = state.people * servingsPerDay * daysPerWeek * gramsPerServing;
      // Recommend the smallest box that covers the week (never under-supply); cap at the largest.
      for (var i = 0; i < sizes.length; i++) {
        if (sizes[i] * punnetGrams >= weeklyGrams) return sizes[i];
      }
      return sizes[sizes.length - 1];
    }
    function popLabel() {
      if (state.box <= 2) return data.pop.one;
      if (state.box <= 4) return data.pop.couple;
      if (state.box <= 6) return data.pop.family;
      return data.pop.house;
    }
    function distribute() {
      state.slots = {};
      var g = state.greens.length ? state.greens : Object.keys(data.varieties).slice(0, 1);
      if (!g.length) return;
      for (var i = 0; i < state.box; i++) { var id = g[i % g.length]; state.slots[id] = (state.slots[id] || 0) + 1; }
    }
    function renderRec() {
      state.box = recommendBox(); distribute();
      q('[data-based]').textContent = 'Based on ' + state.people + ' ' + (state.people > 1 ? 'people' : 'person') +
        ' · ' + (state.meals.length || 1) + ' ' + ((state.meals.length || 1) > 1 ? 'meals' : 'meal') + ' a day';
      updatePrices(); renderSlots();
    }
    // Title format: "4×60g punnet(s)" + " delivered weekly" for any subscription (the box is the
    // weekly quantity even on the monthly plan); no suffix for a one-time order.
    function updateRecTitle() {
      var unit = state.box > 1 ? ' punnets' : ' punnet';
      var freq = state.plan === 'once' ? '' : ' delivered weekly';
      q('[data-rec-title]').textContent = state.box + '×' + data.weight + unit + freq;
    }
    function updatePrices() {
      var b = boxFor(state.box);
      updatePunnetStepper();
      var oneT = oneTimeCents(b);
      var mp = monthPlan(b), wp = weekPlan(b);
      var monthCard = q('.plan[data-plan="month"]'), weekCard = q('.plan[data-plan="week"]');

      if (mp) {
        monthCard.removeAttribute('hidden');
        // The monthly charge covers monthWeeks boxes. Show the normalised weekly price as the
        // headline, the real charge on the "billed" line, and per-serving across the whole month.
        var monthWas = oneT * monthWeeks;
        q('[data-month-week]').textContent = fmtMoney(mp.price / monthWeeks);
        q('[data-month-per]').textContent = fmtMoney(mp.price / (monthWeeks * state.box * servings)) + ' / serving';
        q('[data-month-billed]').textContent = 'Billed ' + fmtMoney(mp.price) + ' every ' + monthWeeks + ' weeks';
        var md = pctOff(monthWas, mp.price);
        var mb = q('[data-month-badge]');
        mb.textContent = md > 0 ? ('Save ' + md + '%') : '';
        mb.style.display = md > 0 ? '' : 'none';
      } else { monthCard.setAttribute('hidden', ''); }

      if (wp) {
        weekCard.removeAttribute('hidden');
        q('[data-week-week]').textContent = fmtMoney(wp.price);
        q('[data-week-per]').textContent = fmtMoney(wp.price / (state.box * servings)) + ' / serving';
        q('[data-week-billed]').textContent = 'Billed ' + fmtMoney(wp.price) + ' weekly';
        var wd = pctOff(oneT, wp.price);
        var wb = q('[data-week-badge]');
        wb.textContent = wd > 0 ? ('Save ' + wd + '%') : '';
        wb.style.display = wd > 0 ? '' : 'none';
      } else { weekCard.setAttribute('hidden', ''); }

      q('[data-once-now]').textContent = fmtMoney(oneT);

      // Keep the selection valid + visually in sync if a plan isn't offered on this variant.
      var avail = { month: !!mp, week: !!wp, once: true };
      if (!avail[state.plan]) state.plan = mp ? 'month' : (wp ? 'week' : 'once');
      qa('.plan').forEach(function (x) { x.classList.toggle('sel', x.dataset.plan === state.plan); });
      updateRecTitle();
    }
    // List the customer's selected varieties (no quantities / steppers) — preferences model.
    function renderSlots() {
      var wrap = q('[data-slots]'); wrap.innerHTML = '';
      var ids = state.greens.length ? state.greens : Object.keys(state.slots);
      if (!ids.length) { wrap.innerHTML = '<div class="box-empty">Pick varieties in the previous step to fill your box.</div>'; validate(); return; }
      ids.forEach(function (id) {
        var v = data.varieties[id] || { name: id, img: '' };
        var row = document.createElement('div'); row.className = 'slot';
        var sw = '<span class="sw"' + (v.img ? ' style="background-image:url(' + v.img + ')"' : '') + '></span>';
        row.innerHTML = sw + '<span class="sn">' + v.name + '</span>';
        wrap.appendChild(row);
      });
      validate();
    }

    /* ---- plan toggle ---- */
    function selectPlan(p) {
      state.plan = p;
      qa('.plan').forEach(function (x) { x.classList.toggle('sel', x.dataset.plan === p); });
      updateRecTitle(); // "per month" / "per week" only applies to a subscription plan
    }
    qa('[data-plan-toggle] .plan').forEach(function (p) {
      p.addEventListener('click', function () { selectPlan(p.dataset.plan); });
    });

    /* ---- punnet stepper: step through the available box sizes ---- */
    function updatePunnetStepper() {
      var i = sizes.indexOf(state.box);
      var cnt = q('[data-punnet-count]'); if (cnt) cnt.textContent = state.box;
      var dec = q('[data-punnet="-1"]'), inc = q('[data-punnet="1"]');
      if (dec) dec.disabled = i <= 0;
      if (inc) inc.disabled = i < 0 || i >= sizes.length - 1;
    }
    qa('[data-punnet-step] [data-punnet]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var d = parseInt(btn.dataset.punnet, 10);
        var i = sizes.indexOf(state.box), ni = i + d;
        if (ni < 0 || ni >= sizes.length) return;
        state.box = sizes[ni];
        distribute(); updatePrices(); renderSlots();
        var cnt = q('[data-punnet-count]');
        if (cnt) { cnt.classList.remove('bump'); void cnt.offsetWidth; cnt.classList.add('bump'); }
      });
    });

    /* ---- navigation ---- */
    function validate() {
      var ok = false;
      if (state.step === 0) ok = !!state.people;
      else if (state.step === 1) ok = state.greens.length >= greensMin;
      else if (state.step === 2) ok = state.meals.length > 0;
      else if (state.step === 3) ok = state.greens.length > 0 && state.box > 0;
      q('[data-next]').disabled = !ok;
    }
    var titleEl = q('[data-title]');
    var titles = [
      titleEl.textContent, // step 0 default already in DOM
      root.dataset.t1 || 'Pick your favourites',
      root.dataset.t2 || 'How often will you eat them?',
      root.dataset.t3 || 'Your recommended box',
      root.dataset.t4 || 'Enjoy!'
    ];
    var navStarted = false;
    function scrollBuilderTop() {
      try { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      catch (e) { window.scrollTo(0, 0); }
    }
    // Funnel analytics: pushed to the dataLayer so GA4/GTM (when installed)
    // can see step progression and adds without any theme changes.
    function track(event, params) {
      try {
        window.dataLayer = window.dataLayer || [];
        var p = params || {};
        p.event = event;
        window.dataLayer.push(p);
      } catch (e) {}
    }
    function go(step) {
      state.step = step;
      track('nutri_builder_step', { builder_step: step });
      qa('.panel').forEach(function (p) { p.classList.toggle('show', parseInt(p.dataset.panel, 10) === step); });
      titleEl.textContent = titles[step] || titleEl.textContent;
      q('[data-prog]').style.width = (step / 4 * 88) + '%';
      qa('[data-steps] .step').forEach(function (st) {
        var i = parseInt(st.dataset.i, 10);
        st.classList.toggle('active', i === step);
        st.classList.toggle('done', i < step);
      });
      var back = q('[data-back]'), next = q('[data-next]');
      back.hidden = !(step > 0 && step < 4);
      if (step === 4) { next.hidden = true; back.hidden = true; }
      else { next.hidden = false; next.firstChild.textContent = (step === 3 ? (root.dataset.addLabel || 'Add to Cart ') : (root.dataset.nextLabel || 'Next ')); }
      if (step === 3) renderRec();
      if (step === 4) renderSummary();
      validate();
      if (navStarted) scrollBuilderTop(); // scroll to the top of the builder on every step change
    }
    q('[data-next]').addEventListener('click', function () {
      if (q('[data-next]').disabled) return;
      if (state.step === 3) { addToCart(); return; }
      if (state.step < 3) go(state.step + 1);
    });
    q('[data-back]').addEventListener('click', function () { if (state.step > 0) go(state.step - 1); });

    /* ---- progress steps: click to jump BACK to a completed step (never forward) ---- */
    qa('[data-steps] .step').forEach(function (st) {
      st.addEventListener('click', function () {
        var i = parseInt(st.dataset.i, 10);
        if (!isNaN(i) && i < state.step) go(i);
      });
    });

    /* ---- deep link: pre-select varieties from ?variety=handle(,handle) ---- */
    function preselectFromUrl() {
      var params;
      try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
      var raw = params.get('variety');
      if (!raw) return;
      var handles = raw.split(',').map(function (h) { return h.trim(); }).filter(Boolean);
      var matched = 0;
      handles.forEach(function (h) {
        var sel = (window.CSS && CSS.escape) ? CSS.escape(h) : h.replace(/"/g, '');
        var btn = root.querySelector('[data-varieties] .variety[data-key="' + sel + '"]');
        if (btn && state.greens.indexOf(h) === -1) {
          state.greens.push(h);
          btn.classList.add('sel');
          matched++;
        }
      });
      // Pre-select the green but stay on step 1 (People) — it stays ticked for when
      // the customer reaches step 2 (Greens), rather than skipping the first step.
      if (matched) { updateVarCount(); }
    }

    /* ---- summary + cart ---- */
    // Preferences model: the customer's favourites as a priority wishlist for the
    // packing team, in selection order (not a fixed per-punnet manifest).
    function preferredGreensString() {
      return state.greens.map(function (h) {
        return data.varieties[h] ? data.varieties[h].name : h;
      }).join(', ');
    }
    function renderSummary() {
      var b = boxFor(state.box);
      var items = (state.greens.length ? state.greens : Object.keys(state.slots)).map(function (id) {
        return '<div><span>' + (data.varieties[id] ? data.varieties[id].name : id) + '</span></div>';
      }).join('');
      var planTxt = state.plan === 'month' ? data.monthName : (state.plan === 'week' ? data.weekName : data.onceName);
      var total = planCents(b);
      var unit = state.box > 1 ? ' punnets' : ' punnet';
      var freq = state.plan === 'once' ? '' : ' delivered weekly';
      q('[data-summary]').innerHTML =
        '<div><span>Box</span><b>' + state.box + '×' + data.weight + unit + freq + '</b></div>' + items +
        '<div><span>Plan</span><b>' + planTxt + '</b></div>' +
        '<div style="border-top:1px solid var(--ng-line);margin-top:6px;padding-top:10px"><span>Total</span><b>' + fmtMoney(total) + '</b></div>';
    }
    // Pull the freshly-rendered cart sections from the server and apply them to the
    // drawer + cart-icon bubble, then open the drawer. A fresh server fetch always
    // includes the line we just added (which is why a manual refresh shows it).
    function sectionInner(html, selector) {
      try { return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML; }
      catch (e) { return null; }
    }
    function refreshCart() {
      var drawer = document.querySelector('cart-drawer');
      var want = drawer ? 'cart-drawer,cart-icon-bubble' : 'cart-icon-bubble';
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(base + '?sections=' + want, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (sec) {
          if (!sec) return;
          if (sec['cart-icon-bubble'] != null) {
            var bubble = document.getElementById('cart-icon-bubble');
            var bh = sectionInner(sec['cart-icon-bubble'], '.shopify-section');
            if (bubble && bh != null) bubble.innerHTML = bh;
          }
          if (drawer && sec['cart-drawer'] != null) {
            var di = sectionInner(sec['cart-drawer'], '#CartDrawer');
            var curInner = drawer.querySelector('#CartDrawer');
            if (curInner && di != null) {
              curInner.innerHTML = di;
              drawer.classList.remove('is-empty');
              curInner.classList.remove('is-empty');
            }
            if (typeof drawer.open === 'function') { try { drawer.open(); } catch (e) {} }
          }
          if (window.publish && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nutri-builder' });
        })
        .catch(function () {});
    }
    function addToCart() {
      var b = boxFor(state.box);
      var err = q('[data-error]');
      err.hidden = true;
      if (!b) { err.textContent = 'This box size is unavailable right now.'; err.hidden = false; return; }
      var planName = state.plan === 'month' ? data.monthName : (state.plan === 'week' ? data.weekName : data.onceName);
      var item = { id: b.variantId, quantity: 1, properties: {
        'Preferred greens': preferredGreensString(),
        'Meals': state.meals.join(', '),
        'Plan': planName
      } };
      var chosen = chosenPlan(b);
      if (chosen && chosen.id != null) item.selling_plan = chosen.id;

      var drawer = document.querySelector('cart-drawer');
      var sections = (drawer && drawer.getSectionsToRender) ? drawer.getSectionsToRender().map(function (x) { return x.section; }) : [];
      var body = { items: [item] };
      if (sections.length) { body.sections = sections; body.sections_url = window.location.pathname; }

      var next = q('[data-next]'); next.disabled = true;

      // Phase 1: the add itself. Only a real fetch/HTTP failure or a cart error
      // response is an "add failed". A post-add render error must NOT land here.
      var httpOk = false, httpStatus = 0;
      fetch(data.cartAddUrl, {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        httpOk = r.ok; httpStatus = r.status;
        return r.text(); // read raw so we can surface non-JSON errors too
      }).then(function (text) {
        var res = {};
        try { res = JSON.parse(text); } catch (e) {}
        // A successful /cart/add.js returns the line item with no `status` error field.
        if (!httpOk || (res && res.status)) {
          // Surface Shopify's real reason; log full detail (incl. the selling_plan we sent) for diagnosis.
          if (window.console && console.error) {
            console.error('[nutri-builder] add to cart failed', { httpStatus: httpStatus, sent: item, response: (res && Object.keys(res).length ? res : text) });
          }
          err.textContent = (res && (res.description || res.message)) || ('Could not add to cart (HTTP ' + httpStatus + '). Please try again.');
          err.hidden = false; next.disabled = false;
          return;
        }
        // Item IS in the cart now. Phase 2: refresh the cart UI authoritatively from the
        // server so the drawer + bubble always reflect the new line — resilient to
        // subscription apps that post-process the cart after the add.
        track('nutri_builder_add_to_cart', {
          variant_id: item.id,
          quantity: item.quantity,
          plan: state.plan,
          people: state.people,
          greens: state.greens.length
        });
        refreshCart();
        go(4); // success regardless of drawer outcome
      }).catch(function (e) {
        if (window.console && console.error) console.error('[nutri-builder] cart add failed:', e);
        err.textContent = 'Network error — please try again.';
        err.hidden = false; next.disabled = false;
      });
    }

    /* ---- how it works (dismissible, remembered) ---- */
    var how = q('[data-how]');
    if (how) {
      var howKey = 'nutriHowDismissed:' + (root.dataset.sectionId || 'builder');
      try { if (localStorage.getItem(howKey) === '1') how.hidden = true; } catch (e) {}
      var howX = q('[data-how-dismiss]');
      if (howX) howX.addEventListener('click', function () {
        how.hidden = true;
        try { localStorage.setItem(howKey, '1'); } catch (e) {}
      });
    }

    go(0);
    preselectFromUrl();
    navStarted = true; // enable scroll-to-top for user navigations (not initial load / deep-link)
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-nutri-builder]').forEach(initBuilder);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutri-pillars"] && !Shopify.designMode) return;
  try {
    
  // Mobile only: flip each pillar card to its back (description) once its
  // centre rises past the viewport middle while scrolling DOWN — late enough
  // to read the title first. Only scrolling UP flips it back to the front.
  (function () {
    var mq = window.matchMedia('(max-width: 560px)');
    var cards = Array.prototype.slice.call(document.querySelectorAll('.nutri-pillars__card'));
    if (!cards.length) return;
    var lastY = window.pageYOffset;
    var ticking = false;

    function update() {
      ticking = false;
      var y = window.pageYOffset;
      var down = y > lastY;
      lastY = y;
      if (!mq.matches) { cards.forEach(function (c) { c.classList.remove('is-flipped'); }); return; }
      var line = window.innerHeight * 0.5; // trigger at viewport centre
      cards.forEach(function (c) {
        var r = c.getBoundingClientRect();
        var mid = r.top + r.height / 2;
        if (down) {
          if (mid < line) c.classList.add('is-flipped');     // flip as it passes centre; never unflip while scrolling down
        } else if (mid > line) {
          c.classList.remove('is-flipped');                  // unflip only while scrolling up
        }
      });
    }
    function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutri-rail"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nutriRailInit) return;
  window.__nutriRailInit = true;
  // Shuffle rails render a 24-article pool; mix it and trim to the display limit.
  document.querySelectorAll('[data-rail-shuffle]').forEach(function (rail) {
    var max = parseInt(rail.getAttribute('data-rail-shuffle'), 10) || 8;
    var cards = Array.prototype.slice.call(rail.children);
    for (var i = cards.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = cards[i]; cards[i] = cards[j]; cards[j] = t;
    }
    cards.forEach(function (card, idx) {
      if (idx < max) rail.appendChild(card); else card.remove();
    });
    rail.scrollLeft = 0;
  });
  function onClick(e) {
    var btn = e.target.closest('[data-rail-target]');
    if (!btn) return;
    var rail = document.getElementById(btn.getAttribute('data-rail-target'));
    if (!rail) return;
    var card = rail.querySelector('.nutri-rail__card');
    var step = card ? card.getBoundingClientRect().width + 20 : 320;
    rail.scrollBy({ left: parseInt(btn.getAttribute('data-dir'), 10) * step, behavior: 'smooth' });
  }
  document.addEventListener('click', onClick);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutri-recipe-hub"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nutriRhubInit) return;
  window.__nutriRhubInit = true;
  document.querySelectorAll('[data-rhub-shuffle]').forEach(function (grid) {
    var step = parseInt(grid.getAttribute('data-rhub-shuffle'), 10) || 12;
    var cards = Array.prototype.slice.call(grid.children);
    for (var i = cards.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = cards[i]; cards[i] = cards[j]; cards[j] = t;
    }
    var shown = step;
    cards.forEach(function (card, idx) {
      if (idx >= shown) card.setAttribute('hidden', '');
      grid.appendChild(card);
    });
    var btn = grid.parentElement.querySelector('[data-rhub-more]');
    if (!btn) return;
    var moreBox = btn.closest('.nutri-rhub__more');
    var nextUrl = btn.getAttribute('data-next-url');
    // Once the 50-article pool is spent, the same button walks to the next page
    // (blogs over 50 posts); otherwise it hides.
    function sync() { moreBox.hidden = shown >= cards.length && !nextUrl; }
    btn.addEventListener('click', function () {
      if (shown >= cards.length) {
        if (nextUrl) window.location.href = nextUrl;
        return;
      }
      cards.slice(shown, shown + step).forEach(function (card) { card.removeAttribute('hidden'); });
      shown += step;
      sync();
    });
    sync();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutri-variety"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initVariety(root) {
    if (!root || root.dataset.varietyInited) return;
    root.dataset.varietyInited = '1';

    var frame = root.querySelector('.nutri-variety__frame .nutri-ph__img');
    var thumbsWrap = root.querySelector('[data-variety-thumbs]');
    if (!frame || !thumbsWrap) return;

    thumbsWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.nutri-variety__thumb');
      if (!btn) return;
      var full = btn.getAttribute('data-full');
      if (full) {
        frame.src = full;
        frame.removeAttribute('srcset');
      }
      thumbsWrap.querySelectorAll('.nutri-variety__thumb').forEach(function (t) {
        t.classList.toggle('is-active', t === btn);
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.nutri-variety').forEach(initVariety);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
